import {all, put, takeLatest} from 'redux-saga/effects';

import {
    activeUsersActions,
    activeUsersOverviewActions,
    averagePlayTimeActions,
    gamesActions,
    returnPlayersActions,
    lifetimePlaysActions,
    myOverallHighlightsActions,
    myTopPerformingGamesActions,
    myTop10GamesActions
} from '../../actions/fortnite-game';
import {NO_DATA_ERROR_CODE} from './constants';

const chartErrorActionCreators = [
    activeUsersActions.getActiveUsersFailed,
    activeUsersOverviewActions.getActiveUsersOverviewFailed,
    averagePlayTimeActions.getAveragePlayTimeFailed,
    returnPlayersActions.getReturnPlayersFailed,
    lifetimePlaysActions.getLifetimePlaysFailed,
    myOverallHighlightsActions.getHighlightsFailed,
    myTopPerformingGamesActions.getTopPerformingGamesFailed,
    myTop10GamesActions.getMyTop10GamesFailed
];

function* checkIfNoGames(action) {
    const {data = {}, error} = action.payload || {};

    if (error || !(data.all && data.all.length)) {
        yield all(
            chartErrorActionCreators.map(actionCreator =>
                put(actionCreator(NO_DATA_ERROR_CODE, null))
            )
        );
    }
}

function* watchNoGames() {
    yield takeLatest(
        [gamesActions.TYPES.GET_GAMES_FAILED, gamesActions.TYPES.GET_GAMES_COMPLETE],
        checkIfNoGames
    );
}

export default watchNoGames;
